import { useState, useEffect, useRef } from "react";
import {
    FormGroup,
    Label,
    Button,
    Alert,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import styled from '@emotion/styled';
import client from '../../common/api';

import BillingWarning from '../BillingWarning';

const ThumbnailImgWrapper = styled.div`

`;

const ThumbnailModal = ({
    showThumbnailModal,
    setShowThumbnailModal,
    roadmapPayload
}) => {
    const [showAlert, setShowAlert] = useState({
        show: false,
        type: '',
        message: '',
    });
    const [thumbnailInfo, setThumbnailInfo] = useState({
        file: '',
        name: '',
    });


    useEffect(() => {
        if (thumbnailInfo.file) {
            uploadThumbnail(thumbnailInfo.file);
        }
    }, [thumbnailInfo.file]);

    return (
        <ThumbnailImgWrapper >

            <Modal
                isOpen={showThumbnailModal}
                centered
                size="lg"
                toggle={() => setShowThumbnailModal(false)}
            >
                <ModalHeader toggle={() => setShowThumbnailModal(false)}>Thumnail Preview</ModalHeader>
                <ModalBody>
                    <img src={roadmapPayload.thumbnail} alt="thumbnail" style={{ width: '100%', height: '100%' }} />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setShowThumbnailModal(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

        </ThumbnailImgWrapper>
    );
};

export default ThumbnailModal;
